import React from 'react';
import { acceptTerms } from '../actions/index'
import { connect } from 'react-redux'

class TermsForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.listenScrollEvent = this.listenScrollEvent.bind(this)
    this.state = { acceptTerms: false }
  }

  listenScrollEvent(event) {
    const termsBox = event.target
    console.log(termsBox.scrollTop, termsBox.scrollHeight - termsBox.offsetHeight - 250)
    if ( termsBox.scrollTop  > (termsBox.scrollHeight - termsBox.offsetHeight - 250) ) {
      this.setState({
        acceptTerms: true
      })
    }
  }

  handleSubmit(event) {
    event.preventDefault()
    const { acceptTerms, email, hex } = this.props
    if(this.state.acceptTerms) {
      acceptTerms(email, hex)
    }
  }

  handleCheckboxChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    })
  }

  render() {
    const { error, request } = this.props
    var rows = [];
    for (var i = 0; i < 99; i++) {
      rows.push('We also combine data among our services and across your devices\n' +
        '                for these purposes. For example, we show you ads based on information\n' +
        '                from your use of messaging and connecting, and we use data from trillions\n' +
        '                of search queries to build spell-correction models that we use\n' +
        '                across all of our services.');
    }
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="FormStaticBox" onScroll={this.listenScrollEvent}>
          <iframe class="scribd_iframe_embed" src="https://www.scribd.com/embeds/354670498/content?start_page=1&view_mode=scroll&access_key=key-Fpf0DB7o5PNpNW9ZKTnc&show_recommendations=true" data-auto-height="false" data-aspect-ratio="0.7729220222793488" scrolling="no" id="doc_19701" width="100%" height="500" frameborder="0"></iframe>
        </div>

        <div className="FormGroup">
          <div className='FormField'>
            <input id="acceptTerms"
                   type="checkbox"
                   className="acceptTerms"
                   name="acceptTerms"
                   checked={this.state.acceptTerms}
                   onChange={this.handleCheckboxChange} />
            <label className="FormLabel terms"
                   htmlFor="acceptTerms">
              I am NOT a US person, citizen or resident of the United States of America
            </label>
          </div>
        </div>

        <div className="FormGroup">
          {/*<input className="FormButton" type="submit" value="I Agree. I'm ready to contribute" />*/}
          <button className={this.state.acceptTerms && !request ? 'FormButton blue' : 'FormButton blue lock'} type="submit"
                  name="submitButton"
                  value="I Agree. I'm ready to contribute"
                  disabled={!this.state.acceptTerms}>
            <span>I HAVE READ AND AGREE TO THE TERMS AND CONDITIONS</span>
          </button>
        </div>

        { error !== ""
          ? <div className="FormError">{error}<span className="pull-right" onClick={this.handleErrorClose}>x</span></div>
          : '' }

      </form>
    );
  }
}

const mapStateToProps = state => {
  const { registrations } = state
  const { email, error, request, hex } = registrations
  return { email, error, request, hex }
}

export default connect(
  mapStateToProps,
  { acceptTerms }
)(TermsForm)



// WEBPACK FOOTER //
// ./src/components/TermsForm.jsx